import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=203f3ca2&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports